import React from 'react';
import { motion } from 'framer-motion';
const SIDEMENU = 'https://cdn.magicpatterns.com/patterns/generated-images/296aaa3d-e34d-4c9c-b221-81c67e359091.jpg';
const GUIDE = 'https://cdn.magicpatterns.com/patterns/generated-images/29dfbef0-0081-4207-8ebe-5451aaff7b76.jpg';
const PROGRESS = 'https://cdn.magicpatterns.com/patterns/generated-images/28ac3c83-71f4-437e-8a92-1f0dce5d1fb8.jpg';
const MIRROR = 'https://cdn.magicpatterns.com/patterns/generated-images/28ac3c83-71f4-437e-8a92-1f0dce5d1fb8.jpg';
type Card = {
  title: string;
  body: string;
  image: string;
  alt: string;
};
const CARDS: Card[] = [{
  title: 'Align Everything',
  body: 'Align goals, habits, projects, and journalling to avoid feeling scattered.',
  image: SIDEMENU,
  alt: 'GPS side menu with icons'
}, {
  title: 'GPS Method',
  body: 'Simplify your big goals with the Guide, Progress, and Self-Reflection framework.',
  image: GUIDE,
  alt: 'GPS home guide page'
}, {
  title: 'Integrated Habit Tracking & Deep Work Sessions',
  body: 'Align your habits and projects with your goals, and visually see your progress to ensure forward progress and consistency.',
  image: PROGRESS,
  alt: 'Progress tracking page'
}, {
  title: 'Discover Yourself',
  body: 'Uncover insights into your patterns, so you can forge your own unique path.',
  image: MIRROR,
  alt: 'GPS mirror insights page'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="w-full bg-white py-24" data-id="element-108" data-mp="3ae09kq8vv0ko">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-109" data-mp="36a0wkhmtajw2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-110" data-mp="3kav653lliqwb">
          <h2 className="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl" data-id="element-111" data-mp="3k89058ecsjg7">
            How it works?
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-112" data-mp="1pw2dndg0eg8l">
            Externalizing your goals into GPS Journal keeps you focused, flexible, and engaged.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-113" data-mp="1kzc0oyzi40re">
          {CARDS.map((card, i) => <motion.article key={card.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.1
        }} className="flex flex-col overflow-hidden rounded-3xl border border-line bg-neutral-50" data-id="element-114" data-mp="3l1jwsopowxes" data-mpi={i}>
              <div className="flex items-center justify-center p-6 pb-0" data-id="element-115" data-mp="7soynu3rp8ag">
                <img src={card.image} alt={card.alt} className="w-full rounded-2xl border border-line bg-white object-cover" data-id="element-116" data-mp="cqqpj17fqbwh" />
              </div>
              <div className="p-7" data-id="element-117" data-mp="ljk7x7i6hrek">
                <h3 className="text-xl font-bold text-ink" data-id="element-118" data-mp="qjor55ah108h">{card.title}</h3>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-119" data-mp="qhc2686applx">{card.body}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}